import HelperPlatform from 'utils/helper-platform'
import { deviceInformation } from 'utils/helper-device-information'
import _ from 'lodash'

const HelperDetect = {
	isCanvasSupported: () => {
		const canvas = document.createElement('canvas');
		const context = canvas.getContext('2d');
		return !!context;
	},
	
	isWebDriverSupported: () => {
		return navigator.webdriver;
	},
	
	isWebRTCSupported: () => {
		return !!window.RTCPeerConnection;
	},
	
	isWindowChromeSupported: () => {
		return window.chrome !== undefined;
	},
	
	isAudioVideoSupported: () => {
		const audio = document.createElement('audio');
		const video = document.createElement('video');
		return !!(audio.canPlayType && video.canPlayType);
	},
	
	isHeadlessPermissionMatched: () => {
		return navigator?.permissions?.query({name: 'notifications'})
            .then(permissionStatus => {
                return Notification.permission === 'denied' && permissionStatus.state === 'prompt';
            })
            .catch(() => {
                return false;
            });
	},
	
	isHeadlessLanguage: () => {
		return !navigator.languages || navigator.languages.length === 0
	},
	
	pluginInstalled: () => {
		return navigator.plugins.length > 0
	},
	
	validate: () => {
		const results = [];
		
		const deviceInfo = deviceInformation();
		if( _.toLower( deviceInfo?.platform ?? '' ).includes( 'headless' ) ) {
			results.push('headless');
		}
		
		// Check canvas support
		if( !HelperDetect.isCanvasSupported() ) {
			results.push('canvas');
		}
		
		// Check the webdriver (true means it is automated)
		if( HelperDetect.isWebDriverSupported() ) {
			results.push('web driver');
		}
		
		// Web RTC
		if( !HelperDetect.isWebRTCSupported() ) {
			results.push('web rtc');
		}
		
		// Chrome
		if( !HelperDetect.isWindowChromeSupported() ) {
			results.push('chrome');
		}
		
		// Audio / Video
		if( !HelperDetect.isAudioVideoSupported() ) {
			results.push('audio video');
		}
		
		// Headless Permission
		if( !HelperDetect.isHeadlessPermissionMatched() ) {
			results.push('headless permission');
		}
		
		// Plugin installed
		if( !HelperDetect.pluginInstalled() ) {
			results.push('plugin');
		}
		
		// Language
		if( HelperDetect.isHeadlessLanguage() ) {
			results.push('language');
		}
		
		return results;
	},
	
	isAutomated: () => {
		if( !HelperPlatform.isWeb() ) {
			return false;
		}
		
		const validateResults = HelperDetect.validate();
		
		window.validateResults = validateResults;
		
		return validateResults.length > 0;
	}
}

export default HelperDetect;
